import React from 'react';
import Navbar from '../Nav';
import NewsPage from '../Parts/NewsPage';
import Footer from '../Footer';
function Homepage() {
  return (
    <>
        <Navbar />
        <NewsPage /> 
        <Footer />
    </>
  );
}

export default Homepage;